import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";

const BASE = "https://us-central1-matriz3dsite.cloudfunctions.net";
const fns = getFunctions(undefined, "us-central1");
export async function request(endpoint, method = "GET", body) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Sua sessão terminou. Entre novamente na conta de administrador.");
  const response = await fetch(`${BASE}/${endpoint}`, {
    method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new Error(data?.error || `Não foi possível concluir a solicitação (${response.status}).`);
  if (!data) throw new Error("O servidor retornou uma resposta inválida. Tente atualizar.");
  return data;
}
const callable = name => async data => (await httpsCallable(fns, name)(data)).data;
export const api = {
  users: () => request("listarUsuarios"),
  coupons: () => request("cupons"),
  usage: () => request("estatisticasUso"),
  support: callable("listarMensagensSuporte"),
  cancellations: callable("listarCancelamentos"),
  reply: callable("responderMensagemSuporte"),
  contact: callable("contatarClienteSuporte"),
  finish: callable("finalizarMensagemSuporte"),
  decide: callable("decidirCancelamento"),
  action: body => request("adminAcoes", "POST", body),
  prices: async () => {
    const snapshot = await getDoc(doc(db, "config", "assinatura"));
    if (!snapshot.exists()) throw new Error("Preços ainda não configurados. Defina os valores abaixo e salve.");
    return snapshot.data();
  },
};
